import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
import ChannelSelector from './ChannelSelector';

interface ComposeModalProps {
  threadId?: string;
  onClose: () => void;
}

export default function ComposeModal({ threadId, onClose }: ComposeModalProps) {
  const [body, setBody] = React.useState('');
  const [channel, setChannel] = React.useState<'in_platform' | 'email' | 'sms'>('in_platform');

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
    >
      <motion.div
        initial={{ scale: 0.8 }}
        animate={{ scale: 1 }}
        className="w-full max-w-lg rounded-lg bg-white dark:bg-gray-900 p-6"
      >
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-semibold">
            {threadId ? 'Reply to thread' : 'New message'}
          </h2>
          <button onClick={onClose} className="p-1 text-gray-500 hover:text-gray-700">
            <X />
          </button>
        </div>
        <ChannelSelector selected={channel} onSelect={setChannel} />
        <textarea
          value={body}
          onChange={(e) => setBody(e.target.value)}
          rows={4}
          className="w-full mt-4 rounded-md border px-3 py-2 focus:outline-hidden focus:ring-2 focus:ring-primary"
          placeholder="Write your message..."
        />
        <div className="mt-4 flex justify-end">
          <button onClick={onClose} className="mr-2 px-4 py-2 text-sm">
            Cancel
          </button>
          <button className="px-4 py-2 rounded bg-primary text-white">Send</button>
        </div>
      </motion.div>
    </motion.div>
  );
}